import { render } from "./InstructorHome.vue?vue&type=template&id=aa11451a&scoped=true"
import script from "./InstructorHome.vue?vue&type=script&lang=js"
export * from "./InstructorHome.vue?vue&type=script&lang=js"

import "./InstructorHome.vue?vue&type=style&index=0&id=aa11451a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa11451a"]])

export default __exports__